import React__default from 'react';
import { Typeahead } from '../../forms/Typeahead/Typeahead.es.js';
import { FloatingMenu } from '../../forms/FloatingMenu/FloatingMenu.es.js';
import { useAppSearchData } from './useAppSearchData/useAppSearchData.es.js';
import { ServiceIcon } from '../ServiceIcon/ServiceIcon.es.js';

const serviceIcon = "_service-icon_go5id_1";
const styles = {
	serviceIcon: serviceIcon
};

const emptyItem = {
  disabled: true,
  name: "No search results found."
};
const dedupeAndTrimWhitespace = (query) => query.replace(/(\s+)/g, " ").trim();
const ServiceTypeahead = ({ apiHostname, "aria-label": ariaLabel, disabledText, id, initialSelectedItem, inputId, isDisabled, labelId, menuAriaLabel, onChange, placeholder, setClearSelection, size, slugFilter, excludeUpcoming = true, includeIsAppAdmin = true, includeIsAppCollaborator = true, onResultsUpdate = () => {
}, renderFloatingMenu = (props) => React__default.createElement(FloatingMenu, Object.assign({}, props)), resultsLimit = 4 }) => {
  const getIconUrlForItem = (item) => item.images.url_32x32;
  const getLabelForItem = (item) => item.name;
  const renderIcon = (item) => {
    if (!item || !item.images) {
      return null;
    }
    return React__default.createElement(
      "span",
      { className: styles.serviceIcon, "data-disabled": isDisabled ? "" : void 0, "data-zds": true },
      React__default.createElement(ServiceIcon, { "aria-hidden": true, serviceName: getLabelForItem(item), size: "small", src: getIconUrlForItem(item) })
    );
  };
  const { apps, loading, onSearch, searchQuery } = useAppSearchData({
    limit: resultsLimit,
    searchDebounceDelay: 300,
    excludeUpcoming,
    includeIsAppAdmin,
    includeIsAppCollaborator,
    apiHostname: apiHostname || "",
    onResultsUpdate
  });
  const filteredApps = !slugFilter ? apps : apps.filter((app) => app.slug !== slugFilter);
  const hasZeroResults = loading === false && searchQuery.length > 0 && filteredApps.length === 0;
  const displayedApps = hasZeroResults ? [emptyItem] : filteredApps;
  return React__default.createElement(Typeahead, {
    "aria-label": ariaLabel,
    autoComplete: "off",
    disabledText,
    getLabelForItem,
    id,
    initialSelectedItem,
    inputId,
    isBusy: loading,
    isDisabled,
    // We are intentionally passing an empty `items` while loading previous
    // search results while searching. This prevents the user from clicking or
    // tapping on a result right after results suddenly change, which is a very
    // frustraing UX.
    //
    // Also passing empty `items` when the `searchQuery` is blank. This is
    // because `AppSearchBackend` returns a default set of apps when a
    // blank search query is specified. When the user type an initial
    // character into the `Typeahead`, these default apps render for a
    // split second, creating the impression of poor search results until
    // the GraphQL query returns.
    items: loading || searchQuery === "" ? [] : displayedApps,
    labelId,
    menuAriaLabel,
    onChange,
    onInputValueChange: (query) => onSearch(dedupeAndTrimWhitespace(query)),
    placeholder,
    renderFloatingMenu: (menuProps) => renderFloatingMenu(Object.assign(Object.assign({}, menuProps), { visibleItems: resultsLimit })),
    renderIcon,
    setClearSelection,
    showEmptyList: true,
    size
  });
};

export { ServiceTypeahead };
//# sourceMappingURL=ServiceTypeahead.es.js.map
